module.exports = __webpack_public_path__ + "images/739c114b.www_1_chs.png";


//////////////////
// WEBPACK FOOTER
// ./images/baseintro/www_1_chs.png
// module id = 456
// module chunks = 0